export default __webpack_public_path__ + "static/media/encantos_logo_yellow.3ea0111a.png";